var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.5H30.5",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5H20.5",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.5V40C15.5 40.663 15.7634 41.2989 16.2322 41.7678C16.7011 42.2366 17.337 42.5 18 42.5H30.5",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 17.5H33C31.6193 17.5 30.5 18.6193 30.5 20V25C30.5 26.3807 31.6193 27.5 33 27.5H48C49.3807 27.5 50.5 26.3807 50.5 25V20C50.5 18.6193 49.3807 17.5 48 17.5Z",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 37.5H33C31.6193 37.5 30.5 38.6193 30.5 40V45C30.5 46.3807 31.6193 47.5 33 47.5H48C49.3807 47.5 50.5 46.3807 50.5 45V40C50.5 38.6193 49.3807 37.5 48 37.5Z",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.f54c86840f4f39eba27835705946948a.svg";
export { ForwardRef as ReactComponent };